export default __webpack_public_path__ + "static/business-share-46d01200fe0ffe33377f960049338627.webp";